/* eslint-disable react/prop-types */
import React from 'react';

import { SelectDropdown } from '@gsa/afp-component-library';

import MakeModelTypeAheadGroup from '../../../../components/make-model/make-model-typeahead-group';
import { useSIMakeModelProvider } from './si-make-model-panel-provider';

const SIMakeModelPanel = () => {
  const state = useSIMakeModelProvider();
  const {
    showChassis,
    requiresChassis,
    modelYear,
    setModelYear,
    getErrors,
    dirtyFields,
    setDirtyFields,
  } = state;

  const getModelYearRange = (previousYears, nextYears) => {
    const currentYear = new Date().getFullYear();
    const years = [{ value: '', label: '-Select-' }];
    for (
      let i = currentYear - previousYears;
      i <= currentYear + nextYears;
      i += 1
    ) {
      years.push({ value: i, label: i.toString() });
    }
    return years;
  };

  const errors = getErrors();
  const modelYearError = errors?.find((e) => e.field === 'modelYear')?.message;

  return (
    <div className="grid-container">
      <div className="grid-row grid-gap-4 flex-align-end">
        <MakeModelTypeAheadGroup
          state={state}
          showChassis={showChassis}
          requiresChassis={requiresChassis}
          fieldWrapperClassName="grid-col flex-1"
          labels={{
            bodyMake: 'Body make',
            bodyModel: 'Body model',
            chassisMake: 'Chassis make',
            chassisModel: 'Chassis model',
          }}
          placeholders={{
            bodyMake: 'Search body make',
            bodyModel: 'Search body model',
            chassisMake: 'Search chassis make',
            chassisModel: 'Search chassis model',
          }}
          preLoadHelpMessages={{
            bodyMake: 'Type to search for makes',
            bodyModel: 'Type to search for models',
            chassisMake: 'Type to search for chassis makes',
            chassisModel: 'Type to search for chassis models',
          }}
        />

        <div className="grid-col flex-1">
          <SelectDropdown
            name="model_year"
            label={<span className="text-bold">Model year</span>}
            required
            onChange={({ target: { value } }) => setModelYear(value)}
            value={modelYear}
            options={getModelYearRange(5, 2)}
            onBlur={() => {
              setDirtyFields((prev) => [...prev, 'modelYear']);
            }}
            errorMessage={
              dirtyFields?.includes('modelYear') && modelYearError
                ? modelYearError
                : undefined
            }
          />
        </div>
      </div>
    </div>
  );
};

export default SIMakeModelPanel;
